
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 44 44","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"var(--status-svg-color)","cx":"22","cy":"22","r":"22"}}),_c('g',{attrs:{"transform":"translate(11 13)","stroke":"#FFF","stroke-width":"2"}},[_c('path',{attrs:{"d":"M16 18v-2a4 4 0 00-4-4H4a4 4 0 00-4 4v2"}}),_c('circle',{attrs:{"cx":"8","cy":"4","r":"4"}}),_c('path',{attrs:{"d":"M22 18v-2a4 4 0 00-3-3.87M15 .13a4 4 0 010 7.75"}})])])])
          )
        }
      }
    